import { NgModule } from '@angular/core';
import { ObjectUtilsService } from './object-utils.service';

@NgModule({
  providers: [ObjectUtilsService],
})
export class UtilitiesModule {}
